/* 6FT Club - slide cart: moves each line's trash (remove) button from the
   top-right corner down into the quantity row, between the quantity
   selector and the price (added 2026-10-06, test). The cart re-draws itself
   after every change, so this re-runs whenever the cart's HTML changes.
   Removing still works: the theme's own click handler finds the button by
   its class, wherever it sits. */
(function () {
  function move() {
    Array.prototype.forEach.call(document.querySelectorAll('.cart-line-item'), function (line) {
      var btn = line.querySelector('.cart-line__top .cart-remove-btn');
      var meta = line.querySelector('.cart-line__meta');
      if (!btn || !meta) return;
      meta.insertBefore(btn, meta.querySelector('.cart-line-price'));
    });
  }
  function start() {
    move();
    var root = document.getElementById('cart-drawer-root');
    if (root && window.MutationObserver) new MutationObserver(move).observe(root, { childList: true, subtree: true });
    document.addEventListener('sixft:cart-updated', move);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();